/**
 * BLOCK: Services Section
 */
 registerBlockType("tornado/services-section", {
    title: "Sliders With Query Select",
    description: __("", "tornado"),
    icon: "editor-insertmore",
    category: "tornado",
    keywords: ["services", "tornado", "home"],
    supports: {
      align: ["full", "wide"],
    },
    attributes: {
      title: {
        type: "string",
        default: "العنوان",
      },
   
      posts_number: {
        type: "string",
        default: 3,
      },
      query: {
        type: "string",
        // default: "services",
      },
      excerpet1: {
        type: "string",
        default: "هذا عنوان مؤقت للمحتوي يقع هنا",
      },
      position: {
        type: 'text',
        selector: '.position',
    },
    
    },
    //==== Edit Mode ====//
    edit: (props) => {
      const { attributes, setAttributes } = props;
      props.setAttributes({ align: "full" });
      const positionHandler = function( position ) {
        return setAttributes( {
            position: position,
        } );
    }

  
      //==== Set new Data ====//
      const set_title = (value) => setAttributes({ title: value });
     const set_posts_number = (value) => setAttributes({ posts_number: value });
      const setExcerpet1 = (value) => setAttributes({ excerpet1: value });
      // const [ option, setOption ] = useState( 'a' );
      const set_query = (value) => setAttributes({ query: value });

      // Rendering in PHP
      return (
        <Panel>
          <InspectorControls key="inspector">
            <PanelBody title={__("Block Options", "tornado")}>
              {/*=== Section Title ===*/}
              <TextControl
                key="title"
                label="عنوان القطعه"
                value={attributes.title}
                onChange={set_title}
              />
           <RadioControl
                    label="اختر نوع المنشور  "
                    selected={ attributes.query }
                    className="position"
                    options={ [
                        { label: 'منتجات', value: 'products' },
                        { label: 'خدمات', value: 'services' },
                        { label : 'المعرض', value : 'multimedia'},
                        { label : 'سابقة اعمالنا', value : 'portfolio'}
                    ] }
                    onChange={ set_query }
                />
              <TextControl
                key="catName"
                label="العنوان الثاني للقطعة"
                value={attributes.excerpet1}
                onChange={setExcerpet1}
              />
 
              {/* //=== URL Input Control ===// */}
              <TextControl
                type="number"
                key="services-number"
                label="عدد البوستات"
                value={attributes.posts_number}
                onChange={set_posts_number}
              />
              {/*=== query Title ===*/}
              <div {...useBlockProps()}>
          
          </div>
            </PanelBody>
          </InspectorControls>
          <PanelBody>
            <ServerSideRender
              block="tornado/services-section"
              attributes={{
                title: attributes.title,
                posts_number: attributes.posts_number,
                query : attributes.query,
                excerpet1 : attributes.excerpet1,
               }}
            />
          </PanelBody>
        </Panel>
      );
    },
    save() {
      // Rendering in PHP
      return null;
    },
  });
  